<div class="nk-content nk-content-fluid">
    <div class="container-xl wide-xl">
        <div class="nk-content-inner">
              <app-back [visivel]="isVisivel"></app-back>
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="nk-block-between">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title page-title">Dashboard</h3>
                            <div class="nk-block-des text-soft">
                                <p>Painel de acompanhamento</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nk-block">
                    <div class="row g-gs">

                        <div class="col-md-4">
                            <div class="card is-dark card-bordered card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle text-white">Total</h6>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount text-white"> {{ formatarMilhar(total) }} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card card-bordered card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Terreno</h6>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount"> {{ formatarMilhar(terreno) }} </span>
                                        <span
                                            [ngClass]="['change text-danger ', onlinePerc < terrenoPerc ? 'up' : 'down']">
                                            <em
                                                [ngClass]="['icon ni ', onlinePerc < terrenoPerc ? 'ni-arrow-long-up' : 'ni-arrow-long-down']"></em>{{terrenoPerc.toFixed(2)}}%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card card-bordered  card-full">
                                <div class="card-inner">
                                    <div class="card-title-group align-start mb-0">
                                        <div class="card-title">
                                            <h6 class="subtitle">Online</h6>
                                        </div>
                                    </div>
                                    <div class="card-amount">
                                        <span class="amount"> {{ formatarMilhar(online) }} </span>
                                        <span
                                            [ngClass]="['change text-danger ', onlinePerc > terrenoPerc ? 'up' : 'down']">
                                            <em
                                                [ngClass]="['icon ni ', onlinePerc > terrenoPerc ? 'ni-arrow-long-up' : 'ni-arrow-long-down']"></em>{{onlinePerc.toFixed(2)}}%
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-7">
                            <div class="card card-bordered h-100">
                                <div class="card-inner">
                                    <div class="card-title-group pb-3 g-2">
                                        <div class="card-title card-title-sm">
                                            <h6 class="title">Total por país de residência</h6>
                                            <p>Total de respostas recolhidas por país de residência selecionado no
                                                questionário.</p>

                                        </div>
                                    </div>
                                    <div class="analytic-ov">
                                        <canvas id="myChart1"></canvas>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->
                        <div class="col-md-6 col-lg-5">
                            <div class="card card-bordered h-100">
                                <div class="card-inner">
                                    <div class="card-title-group align-start pb-3 g-2">
                                        <div class="card-title card-title-sm">
                                            <h6 class="title">Total por país no terreno</h6>
                                            <p>Total de respostas recolhidas por país, realizadas pelos agentes de
                                                terreno.</p>
                                        </div>
                                    </div>
                                    <div class="analytic-au" style="height: 320px;">
                                        <canvas id="myChart2"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-sm-6 col-lg-4">
                            <div class="card card-bordered h-100">
                                <div class="card-inner h-100 stretch flex-column">
                                    <div class="card-title-group">
                                        <div class="card-title card-title-sm">
                                            <h6 class="title">By Device</h6>
                                        </div>
                                    </div>
                                    <div class="device-status my-auto">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4">
                            <div class="card card-bordered h-100">
                                <div class="card-inner">
                                    <div class="card-title-group">
                                        <div class="card-title card-title-sm">
                                            <h6 class="title">By Country</h6>
                                        </div>
                                    </div>
                                    <div class="analytics-map">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4">
                            <div class="card card-bordered h-100">
                                <div class="card-inner">
                                    <div class="card-title-group">
                                        <div class="card-title card-title-sm">
                                            <h6 class="title">Traffic Channel</h6>
                                        </div>
                                    </div>
                                    <div class="traffic-channel">

                                    </div>
                                </div>
                            </div>
                        </div> -->

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>